export function getBlockingAsyncActionTypes(name: string): AsyncActionTypes {
	return {
		REQUEST: `ASYNC_REQUEST`,
		SUCCESS: `${name}__SUCCESS`,
		FAILURE: `${name}__FAILURE`,
	};
}

export function getSilentAsyncActionTypes(name: string): AsyncActionTypes {
	return {
		REQUEST: null,
		SUCCESS: `${name}__SUCCESS`,
		FAILURE: `${name}__FAILURE`,
	};
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/store/constants/util.ts